import { render, staticRenderFns } from "./middle-top.vue?vue&type=template&id=00b889e3&scoped=true&"
import script from "./middle-top.vue?vue&type=script&lang=js&"
export * from "./middle-top.vue?vue&type=script&lang=js&"
import style0 from "./middle-top.vue?vue&type=style&index=0&id=00b889e3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b889e3",
  null
  
)

export default component.exports